import { AbstractFreewheelParameter } from 'tag/ts/tag/ads/freewheel/parameters/AbstractFreewheelParameter';
export class FreewheelParameter extends AbstractFreewheelParameter {
    constructor(key, value, type, name) {
        super({
            key: key,
            value: value,
            type: type,
            name: name
        });
    }
}
